module.exports = __webpack_public_path__ + "img/hzico_5.06e54131.jpg";